import "./module/userAgentChecker.min.js";
import "./module/plugin.js";

var $ = require('jquery');
import ScrollMagic from 'scrollmagic';
// init controller
var controller = new ScrollMagic.Controller();

// build scenes
new ScrollMagic.Scene({
    triggerElement: "#sec01",
    duration: $("#sec01").innerHeight()
})
.setClassToggle("#nav01", "active") // add class toggle
.addTo(controller);


new ScrollMagic.Scene({
    triggerElement: "#sec02",
    duration: $("#sec02").innerHeight()
})
.setClassToggle("#nav02", "active") // add class toggle
.addTo(controller);

new ScrollMagic.Scene({
    triggerElement: "#sec02",
})
.setClassToggle("#gnav", "black") // add class toggle
.addTo(controller);

new ScrollMagic.Scene({
    triggerElement: "#sec03",
    duration: $("#sec03").outerHeight(true)
})
.setClassToggle("#nav03", "active") // add class toggle
.addTo(controller);

new ScrollMagic.Scene({
    triggerElement: "#sec04",
    duration: $("#sec04").innerHeight()
})
.setClassToggle("#nav04", "active") // add class toggle
.addTo(controller);

new ScrollMagic.Scene({
    triggerElement: "#sec05",
    duration: $("#sec05").innerHeight()
})
.setClassToggle("#nav05", "active") // add class toggle
.addTo(controller);

new ScrollMagic.Scene({
    triggerElement: "#sec06",
    duration: $("#sec06").innerHeight()
})
.setClassToggle("#nav06", "active") // add class toggle
.addTo(controller);

new ScrollMagic.Scene({
    triggerElement: "#sec07",
    duration: $("#sec07").innerHeight()
})
.setClassToggle("#nav07", "active") // add class toggle
.addTo(controller);

new ScrollMagic.Scene({
    triggerElement: "#sec08",
    duration: $("#sec08").innerHeight()
})
.setClassToggle("#nav08", "active") // add class toggle
.addTo(controller);

import Rellax from 'rellax';
var rellax = new Rellax('.parallax');

import "./module/modal-multi.js";